import { ChevronLeft, ChevronRight } from 'lucide-react'
import { type DateRange } from 'react-day-picker'
import { Button } from '@/components/ui/button'
import { DateRangePicker } from '@/components/ui/date-range-picker'

interface Props {
  label: string
  onPrevious: () => void
  onNext: () => void
  onToday?: () => void
  todayLabel?: string
  isCustom?: boolean
  customRange?: DateRange
  onCustomRangeChange?: (range: DateRange | undefined) => void
  customPlaceholder?: string
}

export function PeriodNavigator({
  label,
  onPrevious,
  onNext,
  onToday,
  todayLabel,
  isCustom = false,
  customRange,
  onCustomRangeChange,
  customPlaceholder,
}: Props) {
  if (isCustom && onCustomRangeChange) {
    return (
      <div className="flex items-center gap-2">
        {onToday && todayLabel && (
          <Button variant="ghost" size="sm" onClick={onToday}>
            {todayLabel}
          </Button>
        )}
        <DateRangePicker
          value={customRange}
          onChange={onCustomRangeChange}
          placeholder={customPlaceholder}
        />
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2">
      {onToday && todayLabel && (
        <Button variant="ghost" size="sm" onClick={onToday}>
          {todayLabel}
        </Button>
      )}
      <Button variant="outline" size="icon" onClick={onPrevious}>
        <ChevronLeft className="h-4 w-4" />
      </Button>
      <span className="min-w-50 text-center font-medium">{label}</span>
      <Button variant="outline" size="icon" onClick={onNext}>
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  )
}
